import * as core from './core'
import * as html from './html'
import * as components from './components'

export {
    core,
    html,
    components,
}

export const version = '21.2.0'
